import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class TaskAssignmentRepositoryService extends BaseRepositoryService<
  ModelRegistry['task-assignment']
> {
  recordName = 'task-assignment';
  implementMethods = ['createRecord'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/task-assignment': TaskAssignmentRepositoryService;
  }
}
